import { Injectable, inject } from '@angular/core';
import { KeycloakService } from 'src/app/auth/keycloak.service';

@Injectable({
	providedIn: 'root',
})
export class LogoutService {
	private keycloakService = inject(KeycloakService);

	public logout(): void {
		sessionStorage.clear();
		localStorage.clear();
		this.keycloakService.logout();
	}
}
